import {A11yAiProvider} from '../aiSuggest'

export function createDisabledProvider(id: string): A11yAiProvider {
  const reject = () => Promise.reject(new Error(`AI provider "${id}" is not configured`))
  return {
    id,
    capabilities: {
      altText: false,
      linkText: false,
      headerLabel: false,
      tableCaption: false,
      headingHint: false,
      ariaLabel: false,
    },
    suggestAltText: reject,
    suggestLinkText: reject,
    suggestHeaderLabel: reject,
    suggestTableCaption: reject,
    suggestHeadingHint: reject,
    suggestAriaLabel: reject,
  }
}
